export enum ColorMode {
  DarkMode = "DarkMode",
  LightMode = "LightMode",
}
